import instanciaAxios from './InterceptorAxios';
const servicioUsoCfdi = {
    buscarUsoCfdiPorLongitudRfcReceptor(urlBusqueda, rfc) {
        return instanciaAxios.post(urlBusqueda + rfc.length);
    }
}

export default servicioUsoCfdi;